/**
 * live/partials.ts — cosa mostrare nella striscia dei «parziali».
 *
 * PERCHÉ un modulo condiviso: la striscia la disegnano **due** componenti
 * (`ScorebugOverlay` per la grafica di regia/OBS e `ScorePanel` per la card del
 * sito) e devono leggere la stessa regola.
 *
 * Regola (corrente): la striscia mostra **solo i set conclusi**. Il punteggio di
 * un set in corso non è un parziale: cambia a ogni punto, non è confrontabile con
 * gli altri set e affiancato a un 25-15 sembra un risultato. I posti non ancora
 * giocati restano `null` (trattini).
 *
 * (Regola precedente, cambiata su indicazione dell'operatore: includeva anche il
 * set in corso con `current: true`. La funzione mantiene il campo `current` per
 * compatibilità con chi disegna, ma nessun elemento lo riceve più a `true`.)
 */
import type { MatchState } from './state'

export interface PartialSet {
  home: number
  away: number
  /** `true` per il set in corso: si disegna in evidenza, non come concluso. */
  current: boolean
}

/**
 * I parziali da mostrare, in una lista lunga `maxSets` (i posti non ancora
 * giocati sono `null`, così chi disegna può mettere i trattini).
 */
export function displayPartials(state: MatchState, maxSets = 5): Array<PartialSet | null> {
  const played: PartialSet[] = state.setHistory.map((set) => ({
    home: set.home,
    away: set.away,
    current: false,
  }))

  // Il set in corso **non** entra: la striscia è il riepilogo dei set chiusi.
  return Array.from({ length: maxSets }, (_, index) => played[index] ?? null)
}
